import styled from 'styled-components';

import {UPCOMING_KEY, CANCELLED_KEY, COMPLETED_KEY, FAILED_KEY} from '@ibibo/myaccount-reducer';

const getStatusGradient = (status) => {
  switch(status) {
    case UPCOMING_KEY:
      return `linear-gradient(82deg, #5ee7cd, #7dbfcc)`;
    case CANCELLED_KEY:
      return `linear-gradient(262deg, #f09819, #f3d452)`;
    case FAILED_KEY:
      return `linear-gradient(81deg, #ffb480, #ff8080 95%)`;
    case COMPLETED_KEY:
      return `linear-gradient(262deg, #afb3ba, #cfcfcf)`;
    default:
      return `linear-gradient(262deg, #f09819, #f3d452)`;
  }
}

export const HeaderMainWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
    `
);

export const HeaderStatusBack = styled.div(
    props => `
        background-image: ${getStatusGradient(props.status)};
        width:100%;
        display: flex;
        height:18.5rem;
    `
);

export const HeaderDetailOuterWrap = styled.div(
    props => `
        width:100%;
        max-width:120rem;
        margin: 0 auto;
        display: flex;
        padding: ${props.theme.spacing.small.s8} 0 ${props.theme.spacing.large.l25};
        position: relative;
    `
);

export const HeaderDetailInnerWrap = styled.div(
    props =>`
        width:100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    `
);

export const HeaderBkngDetailsWrap = styled.div(
    props => `
        display: flex;
        align-items: flex-start;
        aling-self: flex-end;
        flex-direction: column;
    `
);

export const HeaderBkngStatus = styled.p(
    props => `
        font-size: ${props.theme.font.large.font22};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.black};
    `
);

export const HeaderSubBkngStatus = styled.p(
    props => `
        font-size: ${props.theme.font.large.font12};
        color: ${props.theme.colors.black.base};
    `
);

export const HeaderBkngInfoWrap = styled.div(
    props => `
        display: flex;

    `
);

export const HeaderBkngId = styled.p(
    props => `
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.grey.base};
        padding-right: ${props.theme.spacing.large.l30};

        span{
            font-size: ${props.theme.font.large.font14};
            color: ${props.theme.colors.black.base};
        }
    `
);

export const HeaderStateImgWrap = styled.div(
    props => `
        width: 45.5rem;
        height: 16.3rem;
        position: absolute;
        right:0;
        bottom: -0.3rem;
    `
)